import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// On refresh the browser natively restores the previous scroll position
// ("scrollRestoration: auto") — and it re-applies it AFTER our scrollTo(0,0),
// once content/images load. Switch to manual so the page always opens at the top.
if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
